
import React, { useEffect, useState } from "react";

const WorkflowTemplateRollbackHistory = () => {
  const [history, setHistory] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [filters, setFilters] = useState({
    templateId: "",
    user: "",
    date: ""
  });

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  useEffect(() => {
    fetch("https://c1mgcd1she.execute-api.us-east-1.amazonaws.com/prod/api/workflow_template_rollback/")
      .then((res) => res.json())
      .then((data) => {
        setHistory(data);
        setFiltered(data);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newFilters = { ...filters, [name]: value };
    setFilters(newFilters);
    applyFilters(newFilters);
    setCurrentPage(1);
  };

  const applyFilters = (newFilters) => {
    const result = history.filter((item) => {
      return (
        (!newFilters.templateId || item.template_id.toString().includes(newFilters.templateId)) &&
        (!newFilters.user || item.rolled_back_by.toLowerCase().includes(newFilters.user.toLowerCase())) &&
        (!newFilters.date || item.timestamp.includes(newFilters.date))
      );
    });
    setFiltered(result);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);

  return (
    <div className="container mt-4">
      <h2>Rollback History</h2>
      <div className="row mb-3">
        <div className="col">
          <input className="form-control" placeholder="Filter by Template ID" name="templateId" onChange={handleChange} />
        </div>
        <div className="col">
          <input className="form-control" placeholder="Filter by User" name="user" onChange={handleChange} />
        </div>
        <div className="col">
          <input className="form-control" placeholder="Filter by Date (YYYY-MM-DD)" name="date" onChange={handleChange} />
        </div>
      </div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Rollback ID</th>
            <th>Template ID</th>
            <th>Rolled Back To ID</th>
            <th>Rolled Back By</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((entry) => (
            <tr key={entry.id}>
              <td>{entry.id}</td>
              <td>{entry.template_id}</td>
              <td>{entry.rolled_back_to_id}</td>
              <td>{entry.rolled_back_by}</td>
              <td>{new Date(entry.timestamp).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="d-flex justify-content-center">
        <nav>
          <ul className="pagination">
            {[...Array(totalPages).keys()].map((number) => (
              <li key={number + 1} className={`page-item ${currentPage === number + 1 ? "active" : ""}`}>
                <button className="page-link" onClick={() => setCurrentPage(number + 1)}>
                  {number + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default WorkflowTemplateRollbackHistory;
